import { IFirstDayOfWeek } from '../types';
import { rightShiftArray } from './rightShiftArray';

export const dayNames = (
  firstDayInWeek: IFirstDayOfWeek,
  localeName = 'en-US',
) => {
  const format = new Intl.DateTimeFormat(localeName, { weekday: 'short' })
    .format;
  const days = Array(7)
    .fill('')
    .map((_, day) => format(new Date(Date.UTC(2021, 5, day))));

  return firstDayInWeek === 'Monday' ? days : rightShiftArray(days);
};
